// T7 (agent-bridge), file-size split (CLAUDE.md «Контроль размера файлов» —
// storeHelpers.ts crossed the 2000-line ceiling after an origin/main merge
// landed unrelated growth on top of it while this branch was in flight;
// `resolveGeometryDocumentCommand`, the single largest self-contained
// function in the file, was extracted whole to `storeHelpersResolveCommand.ts`
// to bring it back under the ceiling — see that file's header comment).
//
// This tiny module owns ONLY the `cachedEntitiesLookup` registry slot, split
// OUT of storeHelpers.ts so BOTH storeHelpers.ts and
// storeHelpersResolveCommand.ts can read it without an import cycle between
// those two files (storeHelpers.ts re-exports `resolveGeometryDocumentCommand`
// FROM storeHelpersResolveCommand.ts — a reverse import back INTO
// storeHelpers.ts for the registry accessor would have created exactly the
// cycle CLAUDE.md's dependency-graph gate forbids). No logic beyond the
// registry itself lives here.
//
// Registry slot for the editorStore's `getCachedEntitiesForSpace` lookup.
// editorStore.ts calls `registerCachedEntitiesLookup` once at module init so
// that `syncShellStateFromGeometryDocument` (storeHelpers.ts) and
// `resolveGeometryDocumentCommand` (storeHelpersResolveCommand.ts) can read
// the non-reactive entity cache for huge-import flows without importing
// editorStore directly (which would cause a circular module init).
//
// Why a setter instead of `require("./editorStore")`: the apps/web workspace
// is `"type": "module"`, so CommonJS `require` is not available at runtime
// under ESM (Vite browser bundle, Vitest jsdom environment) — the require()
// call threw `Cannot find module './editorStore'` and broke ~30 unit tests in
// the editor-store / geometry-reducer / dynamic-selection / App suites.
let cachedEntitiesLookup:
  | ((spaceId: string) => readonly import("@dxf-ai-editor/drawing-model").DrawingEntity[] | undefined)
  | null = null;

export function registerCachedEntitiesLookup(
  lookup: (spaceId: string) => readonly import("@dxf-ai-editor/drawing-model").DrawingEntity[] | undefined,
): void {
  cachedEntitiesLookup = lookup;
}

/** Current registered lookup (or `null` before `registerCachedEntitiesLookup` runs). */
export function getCachedEntitiesLookup():
  | ((spaceId: string) => readonly import("@dxf-ai-editor/drawing-model").DrawingEntity[] | undefined)
  | null {
  return cachedEntitiesLookup;
}
